var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.107 143.733H121.601L137.036 108.984L154.962 141.202L163.537 136.465L141.732 97.1833H131.565L116.415 131.279L93.0588 76.7666H82.5238L56.7579 136.914L65.7413 140.752L87.7913 89.3433L111.107 143.733Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0829 86.5666C48.4658 86.8039 43.9644 85.0733 40.6953 81.8042C37.4262 78.5351 35.6957 74.0338 35.9329 69.4166C35.6957 64.7995 37.4262 60.2981 40.6953 57.029C43.9644 53.7599 48.4658 52.0294 53.0829 52.2666C57.7001 52.0294 62.2014 53.7599 65.4705 57.029C68.7396 60.2981 70.4702 64.7995 70.2329 69.4166C70.4702 74.0338 68.7396 78.5351 65.4705 81.8042C62.2014 85.0733 57.7001 86.8039 53.0829 86.5666ZM47.5876 63.9213C49.0295 62.4793 51.0621 61.7933 53.0829 62.0666C55.1038 61.7933 57.1364 62.4793 58.5783 63.9213C60.0203 65.3632 60.7062 67.3958 60.4329 69.4166C60.7062 71.4375 60.0203 73.47 58.5783 74.912C57.1364 76.354 55.1038 77.0399 53.0829 76.7666C51.0621 77.0399 49.0295 76.354 47.5876 74.912C46.1456 73.47 45.4596 71.4375 45.7329 69.4166C45.4596 67.3958 46.1456 65.3632 47.5876 63.9213Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.65 164.15H7.34961V31.85H188.65V164.15ZM17.1496 154.35H178.85V41.65H17.1496V154.35Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.a442e69b2fb03bce744d7096490eb478.svg";
export { ForwardRef as ReactComponent };